const defaultCallbacks = () => ({
  onConfirm: () => {},
  onCancel: () => {},
  onExtra: () => {},
})

const state = ({
    show: false,
    title: '',
    content: '',
    confirmText: 'Продолжить',
    cancelText: 'Отмена',
    confirmBtnColor: 'primary',
    extraText: null,
    extraBtnColor: null,
    extraIcon: null,
    ...defaultCallbacks(),
})

const mutations = {
  showDialog (state, payload) {
    state.show = true
    state.title = payload.title
    state.content = payload.content
    state.confirmText = payload.confirmText || 'Продолжить'
    state.cancelText = payload.cancelText || 'Отмена'
    state.confirmBtnColor = payload.confirmBtnColor || 'primary'
    state.extraText = payload.extraText || null
    state.extraBtnColor = payload.extraBtnColor || null
    state.extraIcon = payload.extraIcon || null
    state.onConfirm = payload.onConfirm
    state.onCancel = payload.onCancel ?? (() => {})
    state.onExtra = payload.onExtra ?? (() => {})
  },
  hideDialog (state) {
    state.show = false
    state.title = ''
    state.content = ''
    state.confirmText = 'Продолжить'
    state.cancelText = 'Отмена'
    state.confirmBtnColor = 'primary'
    state.extraText = null
    state.extraBtnColor = null
    state.extraIcon = null
    Object.assign(state, defaultCallbacks())
  },
}

const getters = {
  onConfirm: state => state.onConfirm,
  onCancel: state => state.onCancel,
  onExtra: state => state.onExtra,
}
const actions = {
   show ({ commit }, payload) {
    commit('showDialog', payload)
  },

  confirm ({ commit, getters }) {
    getters.onConfirm()
    commit('hideDialog')
  },
  cancel ({ commit, getters }) {
    getters.onCancel()
    commit('hideDialog')
  },
  extra ({ commit, getters }) {
    getters.onExtra()
    commit('hideDialog')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
